._EstImpressionsLabel_rq5tr_1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-xxs);
}